var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgToolbarButtonBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 16,
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 16V2s0-1 1-1h6s1 0 1 1v14l-4-5z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarButtonBookmark);
export default __webpack_public_path__ + "static/media/toolbarButton-bookmark.819537bd155e9f263ee50888292c1c7c.svg";
export { ForwardRef as ReactComponent };